import React from 'react'
import PcmcLoginPage from './PcmcLoginPage'

export default function LoginPageComp() {
    return (
        <>
                    <PcmcLoginPage />
        </>
        
    )
}
